import type { UnitLike } from '../types/events.types'

const getUnitLabel = (u: UnitLike): string => {
    const a = u?.attributes
    const property = a?.Property?.data?.attributes
    return a?.Marketing?.Headline ?? property?.Name ?? `Unit #${u?.id ?? ''}`
}

const buildUnitDeepLink = (unitId: string | number): string =>
    `/agent/modalView/view_unit/${unitId}/-/units_nav`

const getUnitAddressText = (u: UnitLike): string => {
    const a = u?.attributes
    const property = a?.Property?.data?.attributes
    const name = property?.Name
    const area = property?.Area
    const headline = a?.Marketing?.Headline
    return [headline ?? name, area].filter(Boolean).join(', ') || getUnitLabel(u)
}

const isUnitActive = (u: UnitLike): boolean => {
    const statuses: string[] = Array.isArray(u?.attributes?.Statuses) ? u.attributes.Statuses : []
    if (statuses.includes('Archived')) return false
    if (statuses.includes('Sold')) return false
    return true
}

export { buildUnitDeepLink, getUnitAddressText, getUnitLabel, isUnitActive }
